import NoData from '../../../../../components/NoData';
import Spinner from '../../../../../components/Spinner';
import { useSelector } from '../../../../../store/store';
import AppliedJobCard from '../../components/AppliedJobCard';
import styles from './style.module.scss';
import {
    selectExamsHistory,
    selectFetchingExamsHistory,
} from '../../../../../store/workspace/selectors';

function JobApplications() {
    const history = useSelector(selectExamsHistory);
    const fetching = useSelector(selectFetchingExamsHistory);

    return (
        <div className={styles.wrapper}>
            <span className={styles.title}>
                Job applications
            </span>
            <div className={styles.list}>
                {fetching && <Spinner />}
                {history.map(i => <AppliedJobCard info={i} />)}
            </div>
            {!fetching && history.length === 0 && <NoData />}
        </div>
    )
};

export default JobApplications;
